module.exports = {
	"next": "next",
	"skip": "Jump to the Cozy creation",
	"cancel": "cancel",
	"back": "back",
	"sign up": "register",
	"add email": "add email account",
	"welcome": "let me in!",
	"confirm": "confirm",
	"step preset": "settings",
	"step import": "import your datas",
	"step email settings": "configure your email",
	"preset email": "e-mail",
	"preset email tip": "It will be used to contact you if you lose your password.",
	"preset name": "name",
	"preset name tip": "It's displayed when you share files with people or invite them to events.",
	"preset password": "password",
	"preset password tip": "A strong password of at least 8 characters is required (special characters recommended).",
	"preset timezone": "timezone",
	"preset timezone tip": "Your timezone is needed to properly display your calendar events.",
	"preset opt-in help": "Allow Cozy to use my usage stats to improve the product.",
	"preset opt-out newsletter": "Subscribe to the Beta Cozy Newsletter (highly recommended).",
	"import from google": "import my data from my Google account",
	"import google account": "Synchronize your Gmail account & import calendar, contacts and photos from Google",
	"import google account tip": "You'll need to sign in to your Google account to allow your Cozy to access to data hosted on Google",
	"leave google title": "Feed your data into Cozy",
	"leave google help me": "I don't understand what I have to do, please help me!",
	"leave google sign in content": "Sign in to your Google account and authorize your Cozy to access it. You will get a complex string. Copy it in your clipboard.",
	"leave google sign in": "Sign in to Google",
	"leave google code content": "Then, copy and paste the code from the popup in this field:",
	"leave google code": "google code",
	"leave google url doc": "https://docs.cozy.io/en/mobile/import-google.html",
	"leave google choice": "Choose what you want to do with your data stored on Google servers:",
	"leave google choice sync gmail": "GMail - Access your email from Cozy",
	"leave google choice contacts": "One-time import of Google Contacts",
	"leave google choice calendar": "One-time import of Google Calendar",
	"leave google choice photos": "One-time import of Google Photos",
	"leave google confirm": "Import data",
	"import error": "An error occurs when trying to import your datas. Please try again later from the dedicated app.",
	"login welcome": "Welcome %{username}",
	"login enter your password": "Please enter your password to access to your Cozy",
	"login password": "password",
	"login otp": "Authentication code",
	"login submit": "sign in",
	"login auth success": "Authentication successful, let's go in!",
	"login recover": "Forget password? Email me instructions",
	"login recover again": "Did not receive it? Send it again",
	"login recover sent title": "Email sent",
	"login recover sent message": "Please check your email, follow instructions to reset your password",
	"login recover error title": "Error sending mail",
	"login recover error message": "Error sending password recovery message, please check your MTA is running or contact server admin",
	"login wrong password title": "Wrong credentials",
	"login wrong password message": "The credentials you entered are incorrect, please try again",
	"reset welcome": "Reset password",
	"reset enter your password": "%{username}, please enter your new password to reset your access",
	"reset password": "password",
	"reset submit": "reset your password",
	"reset auth success": "password successfully resetted",
	"reset wrong password title": "Your password can't be resetted",
	"reset wrong password message": "The pasword you entered is incorrect, or your reset token is expired",
	"setup title": "We're setting up your Cozy…",
	"setup message": "You are now close to have your own personal cloud where your data are stored.",
	"setup on mobile title": "Synchronize your data with your Android device!",
	"setup on mobile message": "Check out our mobile app on Google Play:",
	"welcome title": "Congratulations on taking back control of your personal data!",
	"welcome message": "You can now store your data on your own personal cloud. As opposed to most cloud services, there is no data-mining taking place on your Cozy."
};


/*****************
 ** WEBPACK FOOTER
 ** ./app/locales/en.json
 ** module id = 13
 ** module chunks = 1
 **/